export default [
  {
    path: '/admin/delivery-orders',
    name: 'delivery-order',
    meta: { requiresAuth: true },
    component: () => import('@/pages/wholesale/delivery-order/index-v2.vue')
  },
  {
    path: '/admin/delivery-orders/create',
    name: 'delivery-order-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/wholesale/delivery-order/create.vue')
  },
  {
    path: '/admin/delivery-orders/:id/edit',
    name: 'delivery-order-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/wholesale/delivery-order/edit.vue')
  }
]
